import { watch } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/index';
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted } from 'vue';
import { copy } from '@utils/window-helpers';
export default /*@__PURE__*/_defineComponent({
  __name: 'CusTip',
  props: {
    content: {}
  },
  setup(__props) {
    const props = __props;
    const isTruncated = ref(false);
    const textRef = ref();
    const handleCopy = text => {
      copy(text);
      ElMessage.success('复制成功');
    };
    watch(() => props.content, val => {
      if (textRef.value) {
        textRef.value.innerText = val;
        isTruncated.value = textRef.value.scrollWidth > textRef.value.clientWidth;
      }
    });
    onMounted(() => {
      if (textRef.value) {
        isTruncated.value = textRef.value.scrollWidth > textRef.value.clientWidth;
      }
    });
    return (_ctx, _cache) => {
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      return _openBlock(), _createBlock(_component_el_tooltip, {
        effect: "dark",
        disabled: !isTruncated.value,
        content: __props.content,
        placement: "top",
        "popper-class": "tooltip"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          ref_key: "textRef",
          ref: textRef,
          class: "w-full truncate cursor-pointer",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => handleCopy(__props.content), ["stop"]))
        }, _toDisplayString(__props.content), 513)]),
        _: 1
      }, 8, ["disabled", "content"]);
    };
  }
});